import { configureStore } from "@reduxjs/toolkit";
import formSliceReducer from "../Reducer/FormSlices";
import responseSliceReducer from "../Reducer/ResponseSlices";

const store = configureStore({
  reducer: {
    form: formSliceReducer,
    responses: responseSliceReducer
  },
});
export default store;
